/**
 * How wide each biome's native trees are at their mega size, in pixels, by
 * difficulty. Tree spacing is based on these, so saplings never get boxed in.
 * Generated by art/scripts/export-tree-sizes.mjs from art/trees/trees.json: don't edit by hand.
 */
import type { Biome, Difficulty } from './types.js';

export const MEGA_WIDTH: Record<Biome, Record<Difficulty, number>> = {
  meadow: { trivial: 75, easy: 88, medium: 80, hard: 104 },
  wetland: { trivial: 83, easy: 84, medium: 77, hard: 65 },
  jungleRuins: { trivial: 69, easy: 102, medium: 83, hard: 89 },
  canyon: { trivial: 93, easy: 81, medium: 104, hard: 41 },
  pineRidge: { trivial: 64, easy: 77, medium: 93, hard: 90 },
  woodlandLake: { trivial: 80, easy: 95, medium: 95, hard: 69 },
  coast: { trivial: 102, easy: 58, medium: 108, hard: 100 },
  mountainSummit: { trivial: 103, easy: 65, medium: 60, hard: 73 },
  sacredGrove: { trivial: 75, easy: 85, medium: 74, hard: 101 },
};
